<template>
  <div>
    <v-sheet
      class="mt-n2 secondary5"
      width="100%"
      height="99%"
      style="z-index: 995; position: absolute"
      v-if="showLoading"
    >
      <v-row class="d-flex align-end mt-16" justify-center>
        <v-col cols="12" class="mt-16 pa-0 text-primary">
          <span class="d-flex text-subtitle-2 justify-center mt-16">Cargando</span>
        </v-col>
        <v-col cols="12" class="d-flex mx-auto justify-center">
          <v-progress-circular class="mx-auto" color="primary" indeterminate></v-progress-circular>
        </v-col>
      </v-row>
    </v-sheet>

    <v-sheet
      class="mr-6 pr-6 translucent-gray"
      width="98%"
      height="99%"
      style="z-index: 995; position: absolute"
      v-if="loadSuccess"
    >
      <v-row class="d-flex">
        <v-col cols="12" class="mt-13 pa-0 text-primary"></v-col>
        <v-col cols="12" class="d-flex mx-auto justify-center ml-10">
          <v-progress-circular class="mx-auto" color="primary" indeterminate></v-progress-circular>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: 'VOverlayLoader',
  props: ['status'],
  data() {
    return {
      showLoading: false,
      timeoutId: null,
    };
  },
  computed: {
    loadSuccess() {
      return ['create', 'update', 'save', 'remove', 'success'].includes(this.status);
    },
  },
  watch: {
    status(newStatus) {
      if (newStatus === 'loading') {
        this.showLoading = true;

        if (this.timeoutId) clearTimeout(this.timeoutId);

        this.timeoutId = setTimeout(() => {
          this.showLoading = false;
        }, 300000);
      } else if (newStatus === 'loaded') {
        this.showLoading = false;
      }
    },
  },
};
</script>

<style>
.translucent-gray {
  background-color: rgba(100, 100, 100, 0.5) !important;
}
</style>
